module.exports = __webpack_public_path__ + "img/login-bg-image.99f1b463.webp";